export const ADD_PATIENT_WAITLIST = 'lumahealth/Header/ADD_PATIENT_WAITLIST';
export const ADD_PATIENT_WAITLIST_SUCCESS = 'lumahealth/Header/ADD_PATIENT_WAITLIST_SUCCESS';
export const ADD_PATIENT_WAITLIST_ERROR = 'lumahealth/Header/ADD_PATIENT_WAITLIST_ERROR';

export const CHC_TITLE = 'Change Healthcare';

export const CLEAR_UNREAD_SYSTEM_NOTIFICATIONS = 'lumahealth/Header/CLEAR_UNREAD_SYSTEM_NOTIFICATIONS';
export const CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_SUCCESS = 'lumahealth/Header/CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_SUCCESS';
export const CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_ERROR = 'lumahealth/Header/CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_ERROR';

export const ITEMS_PER_PAGE = 20;

export const LOAD_ACCOUNTS = 'lumahealth/Header/LOAD_ACCOUNTS';
export const LOAD_ACCOUNTS_ERROR = 'lumahealth/Header/LOAD_ACCOUNTS_ERROR';
export const LOAD_ACCOUNTS_SUCCESS = 'lumahealth/Header/LOAD_ACCOUNTS_SUCCESS';

export const LOAD_DATA = 'lumahealth/Header/LOAD_DATA';
export const LOAD_DATA_SUCCESS = 'lumahealth/Header/LOAD_DATA_SUCCESS';
export const LOAD_DATA_ERROR = 'lumahealth/Header/LOAD_DATA_ERROR';

export const LOAD_NOTIFICATIONS = 'lumahealth/Header/LOAD_NOTIFICATIONS';
export const LOAD_NOTIFICATIONS_SUCCESS = 'lumahealth/Header/LOAD_NOTIFICATIONS_SUCCESS';
export const LOAD_NOTIFICATIONS_ERROR = 'lumahealth/Header/LOAD_NOTIFICATIONS_ERROR';

export const SAVE_REFERRAL = 'lumahealth/Header/SAVE_REFERRAL';
export const SAVE_REFERRAL_SUCCESS = 'lumahealth/Header/SAVE_REFERRAL_SUCCESS';
export const SAVE_REFERRAL_ERROR = 'lumahealth/Header/SAVE_REFERRAL_ERROR';

export const SWITCH_ACCOUNT = 'lumahealth/Header/SWITCH_ACCOUNT';
export const SWITCH_ACCOUNT_ERROR = 'lumahealth/Header/SWITCH_ACCOUNT_ERROR';

// constants for switch used on saga and GlobalSearch
export const BROADCAST = 'Broadcast';
export const GROUP = 'Group';
export const WAITLIST = 'Waitlist';
export const PROVIDER = 'Provider';
export const STAFF = 'Staff';
export const FACILITY = 'Facility';
export const APPT_TYPE = 'Appointment Type';
export const APPT = 'Appointment';
export const REMINDER = 'Reminder';
export const REFERRAL = 'Referral';
export const OUTBOUND_REFERRAL = 'Outbound Referral';
export const FORM_TEMPLATE = 'Patient Form Template';
export const FORM = 'Patient Form';
export const OFFER = 'Offer';
export const LUMABOT_FLOW = 'LumaBot Flow';
export const LUMABOT_FLOW_TEMPLATE = 'LumaBot Flow Template';
